module.exports = {
    apiBaseUrl: "//api.mentalika.online",
    externalSiteUrl: "//mentalika.online",
}